<template>
	<v-menu offset-y :z-index="5000">
      <v-btn
        slot="activator"
        
      >
        {{translater.__('Languages')}}
      </v-btn>
      <v-list>
      	<v-list-tile @click="changeLanguage('en')">
      		<v-list-tile-title>{{ translater.__('In english') }}</v-list-tile-title>

      	</v-list-tile>
      	<v-list-tile @click="changeLanguage('fi')">
      		<v-list-tile-title>{{ translater.__('Suomeksi') }}</v-list-tile-title>
      		
      	</v-list-tile>
      </v-list>
    </v-menu>
</template>

<script>
	
	export default {



		name: 'Languages',

		data()
		{
			return {
				
			}
		},

		methods: {
			changeLanguage(l)
			{
				window.localStorage.setItem('lang', l);
				window.location.reload();

			}
		},

		created()
		{
			this.$nextTick(() => {

			})
		},

		computed: {
			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			}
		}
	}

	/*
	
		<v-list>
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          @click=""
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>

	*/

</script>